const RING_INTERVAL_MS = 2400;

let audioContext = null;
let ringTimer = null;

function scheduleChime(context, delaySeconds) {
  const startsAt = context.currentTime + delaySeconds;
  const endsAt = startsAt + 0.24;
  const gain = context.createGain();
  gain.gain.setValueAtTime(0.0001, startsAt);
  gain.gain.exponentialRampToValueAtTime(0.09, startsAt + 0.025);
  gain.gain.exponentialRampToValueAtTime(0.0001, endsAt);
  gain.connect(context.destination);

  [440, 480].forEach(frequency => {
    const oscillator = context.createOscillator();
    oscillator.type = 'sine';
    oscillator.frequency.setValueAtTime(frequency, startsAt);
    oscillator.connect(gain);
    oscillator.start(startsAt);
    oscillator.stop(endsAt);
  });
}

function playRingPattern(context) {
  scheduleChime(context, 0);
  scheduleChime(context, 0.36);
}

export function stopIncomingRingtone() {
  if (ringTimer) window.clearInterval(ringTimer);
  ringTimer = null;
  const context = audioContext;
  audioContext = null;
  if (context && context.state !== 'closed') context.close().catch(() => {});
}

export function startIncomingRingtone() {
  if (typeof window === 'undefined') return false;
  const AudioContext = window.AudioContext || window.webkitAudioContext;
  if (!AudioContext) return false;

  stopIncomingRingtone();
  try {
    audioContext = new AudioContext();
    audioContext.resume?.().catch(() => {});
    playRingPattern(audioContext);
    ringTimer = window.setInterval(() => {
      if (audioContext?.state !== 'closed') playRingPattern(audioContext);
    }, RING_INTERVAL_MS);
    return true;
  } catch (error) {
    stopIncomingRingtone();
    return false;
  }
}

export { RING_INTERVAL_MS };
